import styled, { css, keyframes } from "styled-components";

const backdropFadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const backdropFadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;

export const StyledModalBackdrop = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 20;
  /* background: rgba(0, 0, 0, 0.5); */
  backdrop-filter: blur(8px);
  ${({ animateOut }) => css`
    animation: ${animateOut
      ? css`
          ${backdropFadeOut} 0.3s ease forwards
        `
      : css`
          ${backdropFadeIn} 0.3s ease forwards
        `};
  `}
`;

const modalFadeIn = keyframes`
  from {
    opacity: 0;
    transform:  scale(0.95);
  }
  to {
    opacity: 1;
    transform:  scale(1);
  }
`;

const modalFadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
`;

export const StyledModalContent = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;

  animation: ${({ animateOut }) => (animateOut ? modalFadeOut : modalFadeIn)}
    0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;
`;
